import React, { useState, useEffect } from 'react'

import { styled } from 'goober'
import { useTranslation } from 'react-i18next'
import { ButtonContainer, TourOverlay } from './tourStyles'
import { Button } from '/src/components'
import { Step, TourContentProps } from './ProjectTour'

const TourContent = styled('div')<TourContentProps>`
    pointer-events: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    max-width: 50%;
    max-height: 80%;
    overflow: auto;
    background-color: var(--surface);
    outline: 1px solid var(--input-border);
    box-shadow: 0 2px 5px rgba(0 0 0 / .5);

    ${({ tourStep }) => (tourStep === 1) && `
    position: absolute;
    left:100px;
    width: 400px;
    
   `}
    ${({ tourStep }) => (tourStep === 2) && `
    position: absolute;
    left:100px;
    width: 400px;
    
    `}
    ${({ tourStep }) => (tourStep === 3) && `
    position: absolute;
    right:10px;
    width:200px;

    `}
    ${({ tourStep }) => (tourStep === 4) && `
    position: absolute;
    right:10px;
    width:200px;

    `}
    ${({ tourStep }) => (tourStep === 5) && `
    position: absolute;
    right:10px;
    width:200px;

    `}
    ${({ tourStep }) => (tourStep === 6) && `
    position: absolute;
    right:10px;
    width:200px;

    `}
`

interface TourProps {
  onClose: () => void;
  stepCallback: (step: number) => void;
}

const LandingPageTour: React.FC<TourProps> = ({ onClose, stepCallback }) => {
  const { t } = useTranslation(['common', 'tutorials'])
  const [step, setStep] = useState<number>(0)
  // Define tour steps
  const steps: Step[] = [
    {
      target: '.text', // CSS selector for the element to highlight
      content: t('landing_tour.step1', { ns: 'tutorials' }),
    },
    {
      target: '.banner',
      content: t('landing_tour.step2', { ns: 'tutorials' }),
    },
    {
      target: '',
      content: t('landing_tour.step3', { ns: 'tutorials' }),
    },
    {
      target: '',
      content: t('landing_tour.step4', { ns: 'tutorials' }),
    },
    {
      target: '',
      content: t('landing_tour.step5', { ns: 'tutorials' }),
    },
    {
      target: '',
      content: t('landing_tour.step6', { ns: 'tutorials' }),
    },
    {
      target: '',
      content: t('landing_tour.step7', { ns: 'tutorials' }),
    }

    // Add more steps as needed
  ]
  useEffect(() => {
    stepCallback(step)
  }, [step, stepCallback])

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1)
    } else {
      // End the tour if it reaches the last step
      onClose()
    }
  }

  const handleSkip = () => {
    onClose() // Close the tour
  }

  const handlePrevious = () => {
    if (step > 0) {
      setStep(step - 1)
    }
  }

  return (
    <TourOverlay>
        <TourContent tourStep={step} isBannerStep={steps[step].target === '.banner'}>
          <p>{steps[step].content}</p>
          <ButtonContainer>
            <Button secondary onClick={handleSkip}>{t('tour.skip', { ns: 'common' })}</Button>
            <Button onClick={handlePrevious} disabled={step === 0}>{t('tour.previous', { ns: 'common' })}</Button>
            <Button onClick={handleNext}>{step === steps.length - 1 ? t('tour.finish', { ns: 'common' }) : t('tour.next', { ns: 'common' })}</Button>
          </ButtonContainer>
        </TourContent>
     </TourOverlay>
  )
}

export default LandingPageTour
